import { Content } from '../../types';

export const catCatVillageContent: Content = {
  title: 'הכפר קאט קאט - חוויית תרבות ונוף עוצר נשימה בצפון וייטנאם',
  imageUrl: '/images/vietnam/cat-cat-village/cat-cat-village-wide.jpeg',
  introduction:
    "במרחק קצר מהעיירה סאפה שבצפון וייטנאם שוכן הכפר קאט קאט (Cat Cat Village), אחד הכפרים המסורתיים המפורסמים באזור. הכפר, הממוקם בתוך נוף הררי מרהיב, משמש כבית לבני שבט ההמונג (H'Mong), קבוצה אתנית השומרת על אורח חייה הייחודי מזה מאות שנים. למרות היותו אתר תיירותי, קאט קאט מצליח לשמר מסורות עתיקות, אורחות חיים מסורתיים ותרבות עשירה, ההופכים את הביקור בו לחוויה בלתי נשכחת.",
  sections: [
    {
      title: 'היסטוריה ותרבות מקומית',
      type: 'text',
      content:
        'הכפר קאט קאט נוסד לפני מאות שנים על ידי בני שבט ההמונג השחור, שהיגרו מהאזורים ההרריים של סין, לוייטנאם. השבט ידוע בתרבותו העשירה ובשמירה על מסורות עתיקות, כגון טכניקות אריגה וצביעת בדים בצבעים טבעיים.\n\nהמבקרים בכפר יכולים להיחשף לאורח החיים המקומי דרך סדנאות עבודה, בהן ניתן לצפות בתהליך האריגה המסורתי, יצירת בגדים ססגוניים בעבודת יד, הכנת תכשיטים מקומיים וגילוף עץ ואבן המשמשים למגוון קישוטים וכלים שימושיים. כמו כן, ניתן ללמוד על החקלאות המקומית, הכוללת גידול אורז, תירס וגידולים נוספים המותאמים לאקלים ההררי.',
    },
    {
      title: 'חוויית הביקור בכפר',
      type: 'text',
      content:
        'הביקור בכפר מתחיל בדרך היורדת מסאפה, בה ניתן ליהנות מהנוף ההררי המדהים של טרסות האורז והמפלים המרשימים. עם ההגעה לכפר, המבקרים מוזמנים להסתובב ברחובותיו הציוריים, לבקר בבתי מלאכה מקומיים ולפגוש תושבים העוסקים בעבודות יד מסורתיות.\n\nאחד האתרים המרכזיים בכפר הוא מפל קאט קאט (Cat Cat Waterfall), אחד המפלים היפים ביותר באזור, שסביבו ניתן למצוא נקודות תצפית קסומות המאפשרות ליהנות מהנוף הפראי. כמו כן, לאורך הכפר פזורים דוכנים בהם ניתן לרכוש מוצרי אומנות מקומית, בגדים מסורתיים, תכשיטים ייחודיים ומזכרות אותנטיות.',
    },
    {
      title: 'קולינריה מקומית',
      type: 'text',
      content:
        'המטבח המקומי של קאט קאט משלב בין המסורת הווייטנאמית להשפעות שבטיות. ניתן למצוא בכפר מסעדות קטנות ודוכנים המציעים מנות מקומיות, כמו "תירס קלוי", "בשר מעושן" ומרקים חמים העשויים מירקות שגדלים באזור. כמו כן, ניתן לטעום את יין האורז המקומי, משקה מסורתי חזק בעל טעמים עשירים.',
    },
    {
      title: 'טיפים למבקרים',
      type: 'list',
      content: [
        {
          subtitle: 'עלות כניסה',
          text: 'הכניסה לכפר כרוכה בתשלום סמלי של כ - 100,000 דונג.',
        },
        {
          subtitle: 'דרכי הגעה',
          text: 'מומלץ להגיע רגלית מסאפה, שכן ההליכה מאפשרת ליהנות מהנוף היפהפה. את הדרך חזרה ניתן לעשות במונית, שכן הדרך בכיוון זה הינה בעלייה תלולה.',
        },
        {
          subtitle: 'לבוש מומלץ',
          text: 'יש להגיע עם נעלי הליכה נוחות, במיוחד בעונות הגשומות בהן השבילים עלולים להיות חלקים.',
        },
        {
          subtitle: 'עונות מומלצות לביקור',
          text: 'חודשי הסתיו והאביב הם המומלצים ביותר, כאשר מזג האוויר נעים והנוף ירוק במיוחד.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, הכפר קאט קאט הינו יעד חובה לכל אלו המבקרים בסאפה ומעוניינים לחוות מקרוב את התרבות המקומית של שבט ההמונג. עם שילוב של נוף עוצר נשימה, מסורות עתיקות וקבלת פנים חמה מצד התושבים, זהו מקום שלא כדאי לפספס. בין אם הינכם חובבי טבע, תרבות או היסטוריה - קאט קאט מציעה חוויית ביקור אותנטית ומרתקת שתותיר בכם חותם עמוק.',
    },
  ],
};
